import { PlantTagRecord } from "@/lib/algolia/plantTags";
import { buildSpecificationItems } from "./specifications";
import styled from "styled-components";
import CollapsibleSecion from "@/components/ProductPage/ProductPageHero/CollapsibleSection";
import CollapsibleSection from "@/components/ProductPage/ProductPageHero/CollapsibleSection";
import { useState } from "react";
import { motion, AnimatePresence, stagger } from "motion/react";
import { RichSBData } from "@/components/ProductPage/ProductPageHero/types";
import { render } from "storyblok-rich-text-react-renderer";
import IconRenderer from "@/components/Shared/IconRenderer";

const SpecificationsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const SpecificationsGrid = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 8px;
  padding-top: 16px;
  padding-bottom: 10px;
`;

const SpecItem = styled(motion.div)`
  display: flex;
  gap: 16px;
  padding: 8px 16px;
  align-items: center;
  background: rgba(255, 255, 255, 0);
  border: 1px solid rgba(0, 0, 0, 0.03);
  border-radius: 2px;
  transition:
    background 0.15s ease-out,
    border 0.15s ease-out;
  &:hover {
    background: rgba(255, 255, 255, 0.9);
    border: 1px solid rgba(0, 0, 0, 0.1);
    transition:
      background 0.15s ease-out,
      border 0.15s ease-out;
  }
`;

const SpecItemContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const SpecItemLabel = styled.div`
  color: #686868;
  font-family: Inter;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.25rem;
`;

const SpecItemValue = styled.div`
  color: #292929;
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.25rem;
`;

const SpecItemIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
`;

const containerVariants = {
  hidden: { x: 0, transition: { when: "beforeChildren", delayChildren: 0.5 } },
  visible: { x: 0, transition: { when: "beforeChildren", delayChildren: stagger(0.03, { from: "first" }) } },
};

const itemVariants = {
  hidden: { opacity: 0, y: -30, transition: { duration: 0.25, ease: [0.26, 1, 0.5, 1] } },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.4, ease: [0.26, 1, 0.5, 1] },
  },
};

interface ProductPageInfoSectionProps {
  record: Record<string, unknown>;
  RichSBData: RichSBData;
}

export default function ProductPageInfoSection({ record, RichSBData }: ProductPageInfoSectionProps) {
  const [isOpen, setIsOpen] = useState(true);
  return (
    <CollapsibleSection
      label='Information'
      isDefaultOpen
      hasCustomState
      isCustomOpen={isOpen}
      setIsCustomOpen={setIsOpen}>
      <SpecificationsContainer>
        <SpecificationsGrid
          variants={containerVariants as any}
          initial={isOpen ? "visible" : "hidden"}
          animate={isOpen ? "visible" : "hidden"}
          key='spec_grid'>
          {RichSBData?.content?.infoItems.map(({ body, icon, title, _uid }) => (
            <SpecificationItem key={_uid} label={title} value={body} icon={icon as any} id={_uid} />
          ))}
        </SpecificationsGrid>
      </SpecificationsContainer>
    </CollapsibleSection>
  );
}

const SpecificationItem = ({ label, value, icon, id }: { label: string; value: any; id: string; icon?: string }) => {
  console.log(icon);
  return (
    <SpecItem variants={itemVariants as any} key={id}>
      <SpecItemIcon>
        <IconRenderer icon={[{ icon: icon }]} size={24} />
      </SpecItemIcon>
      <SpecItemContent>
        <SpecItemLabel>{label}</SpecItemLabel>
        <SpecItemValue>{render(value)}</SpecItemValue>
      </SpecItemContent>
    </SpecItem>
  );
};
